
import jQuery from 'jquery';


jQuery(function($){
  var notificationBell = $('[data-cs-header-notifications]');
  notificationBell.on('click', function(e) {
    $('[data-cs-header-notification-dropdown]').toggle();
    notificationBell.toggleClass('is-active');
    CSAnalytics('Notifications Expanded');
  });
  $('#side-menu-close').on('click', function(e){
    e.preventDefault();
    $('#main-sidebar-area').hide();
    $('[data-elementor-type="header"]').show();
    $('#main-content-area').show();
  });
  jQuery('#intercom-link').click( function(e) {
    e.preventDefault();
    Intercom("show")
    return false;
  });
  jQuery('.payment_method').on('change', function(e){
    var bacs = jQuery("#payment_method_bacs:checked").val();
    if(bacs == 'bacs'){
      jQuery('.cs-recurring-billing').hide();
    }else{
      jQuery('.cs-recurring-billing').show();
    }

  });
});

